"use client"

import { zones } from "@/lib/zones"
import { Card } from "@/components/ui/card"
import { motion } from "framer-motion"
import { getContrastColor, getMutedContrastColor } from "@/lib/color-utils"

interface ZoneSelectorProps {
  onSelectZone: (zoneId: string) => void
  selectedZone?: string
}

export function ZoneSelector({ onSelectZone, selectedZone }: ZoneSelectorProps) {
  return (
    <div className="space-y-2 sm:space-y-3">
      {zones.map((zone, index) => {
        const isSelected = selectedZone === zone.id
        const textColor = isSelected ? getContrastColor(zone.color) : undefined
        const mutedTextColor = isSelected ? getMutedContrastColor(zone.color) : undefined

        return (
          <motion.div
            key={zone.id}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.05 }}
          >
            <Card
              className="p-3 sm:p-4 cursor-pointer transition-all active:scale-[0.98] hover:scale-[1.02] hover:shadow-lg min-h-[64px]"
              style={{
                backgroundColor: isSelected ? zone.color : undefined,
                borderLeft: `4px solid ${zone.color}`,
              }}
              onClick={() => onSelectZone(zone.id)}
            >
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="text-2xl sm:text-3xl">{zone.emoji}</div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span
                      className="font-semibold text-xs sm:text-sm shrink-0"
                      style={{ color: mutedTextColor }}
                    >
                      {zone.number}
                    </span>
                    <h3
                      className="font-semibold text-sm sm:text-base text-balance truncate"
                      style={{ color: textColor }}
                    >
                      {zone.name}
                    </h3>
                  </div>
                  <p
                    className="text-xs sm:text-sm line-clamp-1 text-pretty"
                    style={{ color: mutedTextColor }}
                  >
                    {zone.description}
                  </p>
                </div>
              </div>
            </Card>
          </motion.div>
        )
      })}
    </div>
  )
}
